function transformDateData(dataObject: {
  [key: string]: number;
}): { value: string; count: number; moveInMonth: string }[] {
  // Function to convert YYYY-MM format to Mon' YYYY format
  const formatDate = (dateString: string): string => {
    const [year, month] = dateString.split("-");
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1);
    const monthName = date.toLocaleString("en-US", { month: "short" });
    return `${monthName} '${year}`;
  };
  const formatDateYY = (dateString: string): string => {
    const [year, month] = dateString.split("-");
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1);
    const monthName = date.toLocaleString("en-US", { month: "short" });
    const splitYear = year.split("").slice(2).join("");
    return `${monthName} '${splitYear}`;
  };
  const formatMoveInMonth = (moveInMonth: string): string => {
    const splittedDate = moveInMonth.split(" '");
    const month = splittedDate[0].toLowerCase().substring(0, 3);
    const year = splittedDate[1];
    return `${month}-${year}`;
  };

  // Function to generate dates from current date to +11 months in YYYY-MM format
  const generateFutureDates = (): string[] => {
    const currentDate = new Date();
    const futureDates = [];

    for (let i = 0; i <= 11; i++) {
      const futureDate = new Date(currentDate);
      futureDate.setDate(1); // Set to first of month to avoid rollover
      futureDate.setMonth(currentDate.getMonth() + i);

      const year = futureDate.getFullYear();
      // Add 1 because getMonth() returns 0-11
      const month = (futureDate.getMonth() + 1).toString().padStart(2, "0");

      futureDates.push(`${year}-${month}`);
    }

    return futureDates;
  };

  // Generate all future dates we need
  const allFutureDates = generateFutureDates();

  // Create a complete data object including any missing months
  const completeDataObject: { [key: string]: number } = {};

  // First initialize all dates with zero counts
  allFutureDates.forEach((date) => {
    completeDataObject[date] = 0;
  });

  // Then fill in the actual counts from provided data
  Object.entries(dataObject).forEach(([dateKey, count]) => {
    if (allFutureDates.includes(dateKey)) {
      completeDataObject[dateKey] = count;
    }
  });

  // Transform the complete object into array of objects
  return Object.entries(completeDataObject).map(([dateKey, count]) => ({
    value: formatDateYY(dateKey),
    count,
    moveInMonth: formatMoveInMonth(formatDate(dateKey)),
  }));
}

// return Object.entries(dataObject).map(([dateKey, count]) => ({ if +11month logic is not required

export default transformDateData;
